import { Chip } from '@mui/material';
import { Icon } from '@shared/icons';
import { truncate } from '@shared/utils/string';
import type { Table } from '@tanstack/react-table';
import { useDataProvider } from '../DataProviderContext';
import { useFilterLabel } from '../hooks/useFilterLabel';

function getColumnName(columnId: string, table: Table<any, any> | undefined) {
  const column = table?.getColumn(columnId);
  return column?.columnDef.meta?.name ?? columnId;
}

export const ActiveFilters = () => {
  const { table } = useDataProvider();
  const columnFilters = table?.state?.columnFilters ?? [];

  return (
    <>
      {columnFilters.map(({ id }) => (
        <ActiveFilterChip columnId={id} key={id} />
      ))}
    </>
  );
};

interface ActiveFilterChipProps {
  columnId: string;
}

const ActiveFilterChip = ({ columnId }: ActiveFilterChipProps) => {
  const { table } = useDataProvider();
  const column = table?.getColumn(columnId);
  const columnName = getColumnName(columnId, table);
  const displayValue = useFilterLabel(column);

  const handleClear = () => {
    column?.setFilterValue(undefined);
  };

  return (
    <Chip
      label={[truncate(columnName, 20), truncate(displayValue, 20)].join(' ')}
      variant="outlined"
      color="primary"
      onDelete={handleClear}
      deleteIcon={<Icon name="cancel" size="small" />}
    />
  );
};
